<template>
  <div class="mars-ape-layout-header">
    <div style="display: flex;">
      <div class="header-left" style="display: flex">
        <div class="header-nav-logo" @click="goPage">
          <svg class="logoImg">
            <use xlink:href="#icon-logo"></use>
          </svg>
        </div>
      </div>
      <NavMenu/>
    </div>
    <div class="header-right">
      <div style="margin-right: 20px;">
        <WsTag :cmd="cmd" @wsOnMessage="wsOnMessage"/>
        <el-popover
            placement="bottom"
            width="550"
            trigger="click"
        >
          <el-row><span style="font-size: 16px;font-weight: 600;">消息通知</span></el-row>
          <el-row style="display: inline-flex">
            <div :class="'message-title' + (messageActive===0?' message-title-active':'')" @click="tabClick(0)">
              未读消息({{ messageAllData.unread ? messageAllData.unread.length : 0 }})
            </div>
            <div :class="'message-title' + (messageActive===1?' message-title-active':'')" @click="tabClick(1)"
                 style="margin-left: 25px;">已读消息
            </div>
          </el-row>
          <div id="message-div" style="margin-top: 25px;padding-top:5px;height: 500px;overflow:auto">
            <div v-if="messageData.length<1">暂无消息</div>
            <el-timeline :reverse="false" style="font-size:12px">
              <el-timeline-item
                  v-for="(message, index) in messageData"
                  :key="index"
                  :color="messageActive?'#0bbd87':''"
                  @click.native="doMessageToRead(message,index)"
                  style="cursor: pointer"
              >
                <div style="margin-bottom: 3px">
                            <span v-if="!messageActive"
                                  style="width: 50px;font-size:12px;padding: 0 8px;border-radius: 45%;background-color: rgb(217,242,253);color: rgb(4, 153, 255); ">未读</span>
                  <span v-else
                        style="width: 50px;font-size:12px;padding: 0 8px;border-radius: 45%;background-color: rgb(214,245,232);color: rgb(0,194,151); ">已读</span>
                  <span style="font-size: 12px;">{{ message.created_at }}</span>
                </div>
                <div v-if="message.content.operate_type==='apply'">
                  {{ message.content.applicant_roles.join('/') }}&nbsp;&nbsp;{{ message.op_name }} 提交了 <span
                    style="color: #1E9FFF">{{ message.content.customer_name }}</span>的开票申请。
                </div>
                <div v-else-if="message.content.operate_type==='pass'">
                  {{ message.op_roles.join('/') }}&nbsp;{{ message.op_name }}
                  <span style="color: #70b603">通过了</span>
                  {{ message.content.applicant_roles.join('/') }}&nbsp;{{ message.content.applicant }} 提交的
                  <span style="color: #1E9FFF">{{ message.content.customer_name }}</span>的开票申请。
                </div>
                <div v-else-if="message.content.operate_type==='reject'">
                  {{ message.op_roles.join('/') }}&nbsp;{{ message.op_name }}
                  <span style="color: #d9001b">拒绝了</span>&nbsp;
                  {{ message.content.applicant_roles.join('/') }}&nbsp;{{ message.content.applicant }}
                  提交的&nbsp;<span style="color: #1E9FFF">{{ message.content.customer_name }}</span>的开票申请。
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div style="line-height: 60px;font-size: 20px;cursor: pointer" slot="reference">
            <el-badge :is-dot="messageAllData.unread.length>0" style="line-height: 25px;margin-top: 5px;">
              <i class="el-icon-bell"/>
            </el-badge>
          </div>
        </el-popover>
      </div>
      <el-dropdown class="dropDown" @command="handleCommand">
        <div class="right-account">
          <el-image :key="user.avatar" :src="user.avatar" class="right-account-avatar" fit="fill">
            <img slot="error" src="~@/assets/images/avatar.png"/>
          </el-image>
          <span class="right-account-name">{{ user.name }}</span>
          <i class="el-icon-caret-bottom" style="margin-left: 10px;"/>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command='updateInfo'><i class="el-icon-user"></i> 基本资料</el-dropdown-item>
          <el-popover
              placement="left"
              title="我的账号"
              width="400"
              trigger="hover"
              content=""
          >
            <MyAccounts/>
            <el-dropdown-item slot="reference"><i class="el-icon-s-operation"></i> 切换账号</el-dropdown-item>
          </el-popover>

          <el-dropdown-item command='updatePassword'><i class="el-icon-setting"></i> 修改密码</el-dropdown-item>
          <el-dropdown-item divided command='logout'><i class="el-icon-back"></i> 退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {logout} from '@/api/login'
import {messageList, messageToRead} from "@/api/systemSetting";
import WsTag from '@/components/WsTag'
import {mapGetters, mapMutations} from "vuex";
import NavMenu from "@/components/header/NavMenu";
import MyAccounts from "@/views/personal/MyAccounts";
import {lsGet} from "@/utils";
import {logoutClear} from "@/utils/auth";

export default {
  name: "Header",
  components: {
    MyAccounts,
    WsTag, NavMenu
  },
  data() {
    return {
      cmd: 'message',
      screenWidth: document.body.clientWidth,
      messageActive: 0,
      messageForm: {
        page: 1,
        last_page: 100
      },
      messageData: [],
      messageAllData: {
        read: [],
        unread: [],
      },
      visible: false,
      user: {
        avatar: '1'
      },//当前用户
    };
  },
  computed: {
    ...mapGetters(['routePath', 'routeTitle']),
    // user() {
    //   return this.$store.getters.getUser
    // },
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  mounted() {
    let userInfo = lsGet('user')
    this.user = userInfo || {}
    this.handleUserInfo(userInfo)

    const that = this
    this.initMessage();
    setTimeout(function () {
      that.$el.querySelector('#message-div').addEventListener('scroll', that.bindScroll.bind(that))
    })
  },
  methods: {
    ...mapMutations(['handleUserInfo']),
    goPage() {
      if (this.userAuth.show_summary_sale || this.userAuth.show_summary_data || this.userAuth.show_summary_executor) {
        this.$router.push({path: '/home'});
      } else if (this.userAuth.manage_menu_adv_order) {
        this.$router.push({path: '/ad'});
      } else {
        // let menu = this.menu
        // for (let i = 1; i < menu.length; i++) {
        //   if ((this.userAuth[menu[i].meta.auth] || menu[i].meta.auth == 'normal') && !menu[i].meta.hidden) {
        //     if (menu[i].children && menu[i].children.length) {
        //       for (let j = 0; j < menu[i].children.length; j++) {
        //         if ((this.userAuth[menu[i].children[j].meta.auth] || menu[i].children[j].meta.auth == 'normal') && !menu[i].children[j].meta.hidden) {
        //           this.$router.push({path: menu[i].children[j].path});
        //           return
        //         }
        //       }
        //     } else {
        //       this.$router.push({path: menu[i].path});
        //       return;
        //     }
        //   }
        // }
        this.$router.push({path: '/noPermisson'});
      }
    },
    handleCommand(name) {
      if (name === 'logout') {
        logout().then(() => {
          this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` })
          logoutClear()
        })
      } else {
        this.$router.push({name: name});
      }
    },
    tabClick(index) {
      this.messageActive = index
      this.messageData = this.messageActive ? this.messageAllData.read : this.messageAllData.unread
    },
    getMessageList() {
      messageList(this.messageForm).then((result) => {
        this.messageAllData.read = [...this.messageAllData.read, ...result.model.read.data]
        this.messageAllData.unread = [...this.messageAllData.unread, ...result.model.unread.data]
        this.messageData = this.messageActive ? this.messageAllData.read : this.messageAllData.unread
        this.messageForm.last_page = result.model.read.last_page > result.model.unread.last_page ? result.model.read.last_page : result.model.unread.last_page;
      })
    },
    doMessageToRead(message, index) {
      if (this.messageActive) {
        // 已经是已读
        return false
      }
      messageToRead({id: message.id}).then(() => {
        this.messageAllData.unread.splice(index, 1)
        this.messageAllData.read.unshift(message)
      })
    },
    // 处理webSocket服务推送给前端的数据
    wsOnMessage(backData) {
      const data = backData.data
      const cmd = backData.cmd
      if (cmd === this.cmd && data && !Array.isArray(data)) {
        if (data.content) {
          let msg = `【申请开票】申请人：${data.content.applicant || '--'}，客户名称：${data.content.customer_name || '--'}`
          this.$notify({
            title: '您有一条新的消息',
            message: msg,
            type: 'warning',
            duration: 2 * 1000
          })
        } else {
          this.$notify({
            title: '消息通知',
            message: '你一条新的消息，请及时查阅！！！',
            type: 'warning',
            duration: 3 * 1000
          })
        }

        // 组装未读消息
        this.messageAllData.unread.unshift(data)
        if (!this.messageActive) {
          this.messageData = this.messageAllData.unread
        }
      }
    },
    initMessage() {
      // webSocket- 推送的消息
      window['wsOnMessage'] = data => {
        this.wsOnMessage(data)
      };
      if (this.user && this.user.id) {
        this.getMessageList()
      }
    },
    // 滚动加载
    bindScroll(self) {
      const container = self.target;
      const scrollDistance = container.scrollHeight - container.scrollTop - container.clientHeight
      if (this.messageForm.page < this.messageForm.last_page && scrollDistance === 0) {
        this.messageForm.page += 1;
        this.getMessageList()
      }
    },
  }
};
</script>
<style lang="scss">
.mars-ape-layout-header {
  display: flex;
  position: fixed;
  background: #FFFFFF;
  height: 64px;
  box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  overflow: hidden;
  width: 100%;
  font-size: 24px;
  z-index: 99;
  justify-content: space-between;

  .header-right {
    display: flex;
    align-items: center;
    padding-right: 20px;
  }

  .right-account {
    display: flex;
    align-items: center;
    cursor: pointer;

    .right-account-avatar {
      width: 32px;
      line-height: 32px;
      border-radius: 50%;
      display: inline-block;
      margin: 16px 8px 16px 0;
      vertical-align: top;

      img {
        width: 100%;
        display: block;
        border-radius: 50%;
        object-fit: fill;
        border: 1px solid #f2f2f2;
      }
    }
  }
}
</style>
<style scoped>
.header-nav-logo {
  margin-left: 10px;
  line-height: 64px;
  height: 64px;
  padding: 1px;
}

.header-nav-logo img {
  padding: 0 60px 0 40px;
  line-height: 27px;
  height: 27px;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  overflow: hidden;
}

.logoImg {
  width: 192px;
  height: 27px;
  padding: 15px 10px 10px 10px;
}

</style>
<style scoped>
.menu-item {
  margin: 0 1px !important;
}

li.menu-item i {
  color: rgb(89, 89, 89);
}

.el-submenu.is-active .el-submenu__title i {
  color: rgb(224, 63, 61);
}

ul.el-menu--popup-bottom-start {
  margin-top: 0;
}

.el-menu--horizontal .el-menu.el-menu--popup li.el-menu-item {
  padding: 0 10px 0 10px;
}

div.el-menu--horizontal {
  width: 145px;
  overflow: hidden;
  box-shadow: rgba(186, 186, 186, 0.5) 0px 0px 10px 0px;
}

ul.el-menu--popup {
  padding: 8px 10px;
}

.message-title {
  cursor: pointer;
}

.message-title-active {
  color: rgb(4, 153, 255);
}
</style>
